import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Spend Summary Report"
  reportDownloadName = "spendSummaryReport"
  apiReportName = "spendSummaryReport"
/>
